import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import styles from 'pages/Dashboard/Dashboard.scss';

export const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <div className={styles.header}>{user && <h1>Вітаємо, {user?.name}!</h1>}</div>

      <section className={styles.content}>
        <div className={styles.underDevelopment}>
          <FontAwesomeIcon className={styles.icon} icon={faGear} spin />

          <h2 className={styles.title}>Сторінка розробляється</h2>

          <p className={styles.description}>
            Ми працюємо над створенням чудового досвіду для вас. Незабаром тут з'явиться персоналізована панель
            управління з корисними функціями та інструментами.
          </p>
        </div>
      </section>
    </>
  );
};
